import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sentenceCase",
  standalone: false,
})
export class SentenceCasePipe implements PipeTransform {
  constructor() {}
  transform(value: unknown): string {
    const text = (value ?? "").toString().trim();
    return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "";
  }
}
